var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7219 6.01332V15.1604C20.7219 16.272 19.8132 17.1737 18.6929 17.1737H17.289V9.6248C17.289 8.51315 16.381 7.61217 15.2607 7.61217H7V6.01332C7 4.90167 7.90802 4 9.02835 4H18.6936C19.8139 4 20.7226 4.90167 20.7226 6.01332H20.7219Z",
    fill: "url(#paint0_linear_468_75508)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2215 20.6802H5.55104C4.42033 20.6802 3.5 19.7609 3.5 18.63V9.40928C3.5 8.279 4.41964 7.35901 5.55104 7.35901H15.2215C16.3522 7.35901 17.2726 8.27831 17.2726 9.40928V18.63C17.2726 19.7603 16.3529 20.6802 15.2215 20.6802ZM5.55104 7.4012C4.44317 7.4012 3.54222 8.30183 3.54222 9.40928V18.63C3.54222 19.7374 4.44317 20.6381 5.55104 20.6381H15.2215C16.3294 20.6381 17.2304 19.7374 17.2304 18.63V9.40928C17.2304 8.30183 16.3294 7.4012 15.2215 7.4012H5.55104Z",
    fill: "url(#paint1_linear_468_75508)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2334 7.37146H5.56356C4.44226 7.37146 3.53326 8.28011 3.53326 9.40098V18.621C3.53326 19.7419 4.44226 20.6505 5.56356 20.6505H15.2334C16.3547 20.6505 17.2636 19.7419 17.2636 18.621V9.40098C17.2636 8.28011 16.3547 7.37146 15.2334 7.37146Z",
    fill: "url(#paint2_linear_468_75508)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1448 15.6748H5.52098C5.22768 15.6748 4.99054 15.4287 4.99054 15.1259C4.99054 14.8224 5.22838 14.577 5.52098 14.577H12.1448C12.4381 14.577 12.6752 14.8231 12.6752 15.1259C12.6752 15.4294 12.4374 15.6748 12.1448 15.6748Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40529 17.8706H5.51595C5.22543 17.8706 4.99054 17.6245 4.99054 17.3217C4.99054 17.0182 5.22612 16.7728 5.51595 16.7728H9.40529C9.6958 16.7728 9.93068 17.0189 9.93068 17.3217C9.93068 17.6252 9.69512 17.8706 9.40529 17.8706Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75508",
    x1: 7.00834,
    y1: 4.41168,
    x2: 19.67,
    y2: 18.1768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D871F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C21CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75508",
    x1: 3.5,
    y1: 14.0199,
    x2: 17.2726,
    y2: 14.0199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75508",
    x1: 3.53326,
    y1: 14.0113,
    x2: 17.2636,
    y2: 14.0113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorDoc);
export default __webpack_public_path__ + "static/media/color-doc.42fcfcf1c0d8efc4b54c980b6e73eb79.svg";
export { ForwardRef as ReactComponent };